module.exports = {"610322100":"城关镇","610322101":"虢王镇","610322102":"彪角镇","610322103":"横水镇","610322104":"田家庄镇","610322105":"糜杆桥镇","610322107":"南指挥镇","610322108":"陈村镇","610322109":"长青镇","610322110":"柳林镇","610322111":"姚家沟镇","610322112":"范家寨镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/610322.json
// module id = 2589
// module chunks = 0